<div class="custom-ag-table">
    <div class="custom-ag-table-inner">
        <ag-grid-angular [id]="idString" [ngStyle]="style" class="ag-theme-alpine normal" [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef" [rowData]="rowData" [rowSelection]="rowSelection" [animateRows]="true"
            [components]="frameworkComponents" [domLayout]="domLayout" (rowSelected)="onRowSelected($event)"
            [gridOptions]="gridOptions" (rowDoubleClicked)="onRowDoubleClicked($event)"
            (gridReady)="onGridReady($event)"></ag-grid-angular>
        <div class="page-size-section">
            <select (change)="onPageSizeChanged()" id="{{idString}}-select" [(ngModel)]="paginationPageSize"
                class="form-select form-select-sm">
                <option *ngFor="let size of paginationPageSizes">
                    {{size}}
                </option>
            </select>
        </div>
    </div>
</div>